module.exports = __webpack_public_path__ + "img/co-landing.0953248.jpg";